import { Button } from "@mui/material";
import Upload from "@mui/icons-material/Upload";

const convertToCSV = (data: any[]) => {
  const array = typeof data !== "object" ? JSON.parse(data) : data;
  let str = "";

  if (array.length > 0 && typeof array[0] === "string") {
    // handle array of strings
    str = array.join("\r\n");
  } else {
    // handle array of other
    for (let i = 0; i < array.length; i++) {
      let line = "";
      for (let index in array[i]) {
        if (line !== "") line += ",";

        line += array[i][index];
      }
      str += line + "\r\n";
    }
  }

  return str;
};

const ExportCSV = ({
  data,
  headers,
  fileName,
  disabled = false,
}: {
  data: any;
  headers: string[];
  fileName: string;
  disabled?: boolean;
}) => {
  const exportCsv = () => {
    const csvData = new Blob(
      [headers.join(",").concat("\n"), convertToCSV(data)],
      { type: "text/csv" }
    );

    const csvURL = URL.createObjectURL(csvData);
    const link = document.createElement("a");
    link.href = csvURL;
    link.download = `${fileName}-${new Date().toISOString()}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Button
      variant="contained"
      disabled={disabled}
      endIcon={<Upload />}
      onClick={exportCsv}
    >
      Export
    </Button>
  );
};

export default ExportCSV;
